<template>
  <div class="list">
    <div class="btnBox">
      <div
        @click="appointmentTypeHandle('team')"
        :class="appointmentType === 'team' ? 'btn_active' : 'btn'"
      >团队预约</div>
      <div
        @click="appointmentTypeHandle('fit')"
        :class="appointmentType === 'fit' ? 'btn_active' : 'btn'"
      >散客预约</div>
    </div>
    <div class="searchBox">
      <img src="../../../../../assets/image/sousuo_ic_daoyou @2x (1).png" />
      <input type="text" v-if="appointmentType === 'team'" v-model="name" placeholder="搜索旅行社名称或景区名称" @click="goSearch(1)" />
      <input type="text" v-if="appointmentType === 'fit'" v-model="name" placeholder="搜索景区名称" @click="goSearch(2)" />
    </div>
    <div class="centerBox">
      <div class="topChoice">
        <div class="allScenicSelect" @click="selectCity">
          <span class="city">{{ cityChange }}</span>
          <img v-if="localNum != 3" src="../../../../../assets/image/ic_jiantou_down@2x.png" alt />
        </div>
        <div v-if="showScenic" class="allScenicSelect" @click="allScenic">
          <span class="city">{{ scenicValue }}</span>
          <img src="../../../../../assets/image/ic_jiantou_down@2x.png" alt />
        </div>
        <!-- 全部旅行社 -->
        <div v-show="appointmentType === 'team'" class="allScenicSelect" @click="allTravel">
          <span class="city">{{ travelValue }}</span>
          <img src="../../../../../assets/image/ic_jiantou_down@2x.png" alt />
        </div>
        <div class="allScenicSelect" @click="selectTime">
          <span class="city">{{ beginTime ? `${beginTime} ~ ${endTime}` : '选择时间' }}</span>
          <img src="../../../../../assets/image/ic_jiantou_down@2x.png" alt />
        </div>
      </div>
      <div class="scenicList" v-if="listData.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMoreList"
          v-if="listData.length > 0"
          :offset="100"
          :error.sync="error"
        >
          <div
            class="scenicItem"
            @click="toScenicDetele(ind)"
            v-for="(item, ind) in listData"
            :key="ind"
          >
            <div class="scenicTitle">{{ item.orgName }}</div>
            <div class="scenicNav">
              <div class="scenicLeft">
                <div v-if="appointmentType === 'team'" class="scenicLeftItem">
                  <div class="scenicLeftTitle">旅⾏社：</div>
                  <div class="scenicLeftNav">{{ item.travelAgentName }}</div>
                </div>
                <div v-if="appointmentType === 'fit'" class="scenicLeftItem">
                  <div class="scenicLeftTitle">预约单号：</div>
                  <div class="scenicLeftNav">{{ item.appointNo }}</div>
                </div>
                <div v-if="appointmentType === 'team'" class="scenicLeftItem">
                  <div class="scenicLeftTitle">行程单号：</div>
                  <div class="scenicLeftNav">{{ item.travelItineraryNo }}</div>
                </div>
              </div>
              <div class="scenicRight">
                <div class="scenicRightPeople">{{ item.appointNum }}</div>
                <div>预约人数(人)</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="noScenicList" v-else>
        <div class="noScenic">
          <div class="noScenicItem">
            <div class="noScenicItemImg">
              <img src="../../../../../assets/appointment/ic_wuxingxi@3x.png" alt />
            </div>
            <div class="noScenicItemContent">该筛选条件下，没有查询到任何数据哦</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 全部景区 -->
    <van-action-sheet v-model="allScenicShow" title="景区选择">
      <div class="contentCenter">
        <div class="search">
          <span>{{ cityChange }}所有景区：共{{ scenicList.length - 1 }}个</span>
        </div>
        <div class="content">
          <div
            class="contentAll"
            v-for="(item, index) in scenicList"
            :key="index"
            :class="{ 'contentAllColor': index == scenicInd ? true : false }"
            @click="getScenicItem(index)"
          >
            <div class="contentAllTitle">{{item.name}}</div>
            <div>
              <img
                v-if="index == scenicInd"
                src="../../../../../assets/appointment/icon_ts_gx@3x.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="cancelIcon">
        <div @click="cancelScenic">
          <img src="../../../../../assets/appointment/ic_close_sousuo@3x.png" alt />
        </div>
      </div>
    </van-action-sheet>

    <!-- 全部旅行社 -->
    <van-action-sheet v-model="allTravelShow" title="旅行社选择">
      <div class="contentCenter">
        <div class="search">
          <span>{{ cityChange }}所有旅行社：共{{ travelList.length - 1 }}个</span>
        </div>
        <div class="content">
          <div
            class="contentAll"
            v-for="(item, index) in travelList"
            :key="index"
            :class="{ 'contentAllColor': index == travelInd ? true : false }"
            @click="getTravelItem(index)"
          >
            <div class="contentAllTitle">{{ item.travelName }}</div>
            <div>
              <img
                v-if="index == travelInd"
                src="../../../../../assets/appointment/icon_ts_gx@3x.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="cancelIcon">
        <div @click="cancelTravel">
          <img src="../../../../../assets/appointment/ic_close_sousuo@3x.png" alt />
        </div>
      </div>
    </van-action-sheet>

    <!-- 区域 -->
    <!-- <common-picker :cols="cols" ref="commonpicker" :typeList="typeListCity"  @getTypeValue="getCityValue"></common-picker> -->
    <common-picker
      ref="commonpicker"
      :typeList="typeListCity"
      :cols="cols"
      @getTypeValue="getCityValue"
    ></common-picker>
    <!-- 时间区域 -->
    <rangTime ref="rangeTime" @getCurrentTime="getCurrentTime" :allowSameDay="true"></rangTime>
  </div>
</template>

<script>
import api from "../../../../../service/modules/appointment";
import commonPicker from "../../../../components/base/commonPicker";
import rangTime from "../../../../../components/rangTime1";
import { timeType1 } from "../../../../../utils/configJson";
import { storageGetByName } from '../../../../../utils/helper';

export default {
  components: {
    "common-picker": commonPicker,
    rangTime
  },
  data() {
    return {
      appointmentType: this.$route.query.appointmentType || "team",
      finished: false,
      loading: false,
      cols: 2,
      typeListCity: timeType1,
      cityChange: "",
      areaCode: '',
      beginTime: "",
      endTime: "",

      listData: [],
      // name: this.$route.query.name || '',
      name: "",

      allScenicShow: false,
      scenicInd: 0,
      scenicValue: "全部景区",
      orgId: this.$route.query.orgId || "",
      orgName: this.$route.query.scenicName || "",
      scenicList: [],

      allTravelShow: false,
      travelInd: 0,
      travelValue: this.$route.query.travelName || "全部旅行社",
      travelAgentId: this.$route.query.travelId || "",
      channelType: 1,
      travelList: [],

      pageIndex: 1,
      pageSize: 10,
      total: 0,
      error: false,
      /** areaLevel  1省,2市,3区县 */
      localNum: '',
      showScenic: false
    };
  },
  async created() {
    let auth = await storageGetByName('auth')
    console.log('auth', auth)
    if (auth) {
      this.areaCode = auth.areaCode
      this.localNum = auth.areaLevel
    }
    if (!this.$route.query.appointmentType && sessionStorage.getItem('appointmentType')) {
      this.appointmentType = sessionStorage.getItem('appointmentType');
      // 避免初始为fit而一直跳转默认到fit
      sessionStorage.removeItem('appointmentType');
    }
    if (this.appointmentType == 'fit') {
      this.channelType = 2;
    }
    this.getAppointmentPageList(); /** 列表 */
    this.getTravelList(); /** 入园预约单旅行社接口 */
    this.getOrgList(); /** 入园预约单景区接口 */
    this.getCity();
  },
  methods: {
    // 选择预约类型
    appointmentTypeHandle(type) {
      this.appointmentType = type;
      this.listData = [];
      // 清空时间选择
      this.beginTime = "";
      this.endTime = "";
      this.pageIndex = 1;
      
      this.showScenic = false;
      this.cityChange = "";
      this.areaCode = JSON.parse(localStorage.getItem("auth")).areaCode;
      this.getCity();
      this.getTravelList();
      
      this.orgId = ''; /** 重置景区 **/
      
      /** 重置旅行社 **/
      this.travelAgentId = '';
      this.travelValue = '全部旅行社';
      this.travelInd = 0;
      
      if (type === "team") {
        // 团队预约
        this.channelType = 1;
        this.getAppointmentPageList();
      } else if (type === "fit") {
        // 散客预约
        this.channelType = 2;
        this.getAppointmentPageList();
      }
      this.$router.push({ query: {} });
    },
    cancelScenic() {
      this.allScenicShow = false;
    },
    cancelTravel() {
      this.allTravelShow = false;
    },
    loadMoreList() {
      this.getAppointmentPageList();
    },
    getCity() {
      api.city({ areaCode: this.areaCode }).then(res => {
        if (this.localNum === 1) {
          res.data[0].shortName = res.data[0].shortName == '云南省'? '全省': res.data[0].shortName
          res.data[0].fullName = res.data[0].fullName == '云南省'? '全省': res.data[0].fullName
          this.cityChange = res.data[0].shortName;
          this.cols = 2;
          let obj = {
            text: res.data[0].shortName,
            value: res.data[0].areaCode,
            shortName: res.data[0].shortName,
            children: [
              {
                text: "--",
                value: "",
                shortName: "",
              }
            ]
          };
          let arr = res.data[0].children.map(
            ({ fullName, areaCode, shortName, children }) => {
              return {
                text: shortName || fullName,
                value: areaCode,
                shortName,
                children: children
                  ? children.map(({ fullName, areaCode, shortName }) => {
                      return {
                        text: shortName || fullName,
                        value: areaCode,
                        shortName,
                      };
                    })
                  : []
              };
            }
          );
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].children) {
              let cityChild = [
                { text: "--", value: "", shortName: "" }
              ];
              let newArr = arr[i].children.concat([]);
              arr[i].children = cityChild.concat(newArr);
            }
          }
          arr.unshift(obj);
          this.typeListCity = [];
          this.typeListCity.push(arr);
        } else if (this.localNum === 2) {
          this.cols = 2;
          this.cityChange = res.data[0].shortName;
          let brr = [];
          brr.push(res.data[0]);
          brr = brr.map(({ fullName, areaCode, shortName, children }) => {
            return {
              text: shortName || fullName,
              value: areaCode,
              shortName: shortName,
              children: children
                ? children.map(({ fullName, areaCode, shortName }) => {
                    return {
                      text: shortName || fullName,
                      value: areaCode,
                      shortName
                    };
                  })
                : []
            };
          });
          for (var j = 0; j < brr.length; j++) {
            if (brr[j].children) {
              let cityChild = [
                {
                  text: "--",
                  value1: "--",
                  regionType: ""
                }
              ];
              let newArr = brr[j].children.concat([]);
              brr[j].children = cityChild.concat(newArr);
            }
          }
          this.typeListCity = [];
          this.typeListCity.push(brr);
        } else if (this.localNum === 3) {
          this.cityChange = res.data[0].shortName;
        }
      });
    },

    /** 获取列表data */
    getAppointmentPageList() {
      this.loading = true;
      let params = {
          areaCode: this.areaCode,
          startDate: this.beginTime,
          endDate: this.endTime,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          orgId: this.orgId,
          travelAgentId: this.travelAgentId,
          channelType: this.channelType
      }
      api.inParkTravel(params)
        .then(res => {
          if (res.ret === 0) {
            this.finished = false;
            this.loading = false;
            this.listData = [...this.listData, ...res.data.list];
            this.pageIndex++;
            this.total = res.data.pageination.total;
            if (
              this.total <=
              res.data.pageination.currentPage * res.data.pageination.pageSize
            ) {
              this.finished = true;
            }
          } else {
            this.$Message.error("res.data.msg");
          }
        });
    },

    /** 景区 下拉窗 */
    getOrgList() {
      api.scenic({ areaCode: this.areaCode }).then(res => {
        let obj = {
          name: "全部景区",
          id: ""
        };
        res.data.unshift(obj);
        this.scenicList = res.data;
      });
    },

    /** 旅行社 下拉窗 */
    getTravelList() {
      api.travelAgencyList({ areaCode: this.areaCode }).then(res => {
        let obj1 = {
          travelName: "全部旅行社",
          travelId: ""
        };
        res.data.unshift(obj1);
        this.travelList = res.data;
      });
    },

    /** 获取全部旅行社弹窗唤醒 */
    allTravel() {
      this.allTravelShow = true;
    },

    /** 旅行社弹窗项 */
    getTravelItem(index) {
      this.travelInd = index;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.listData = [];
      this.travelValue = this.travelList[index].travelName;
      this.allTravelShow = false;
      this.travelAgentId = this.travelList[index].travelId;
      this.getAppointmentPageList();
    },

    /** 景区弹窗项 */
    getScenicItem(index) {
      this.pageIndex = 1;
      this.pageSize = 10;
      this.listData = [];
      this.scenicInd = index;
      this.scenicValue = this.scenicList[index].name;
      this.allScenicShow = false;
      this.orgId = this.scenicList[index].id;
      this.orgName = this.scenicList[index].name;
      this.getAppointmentPageList();
    },
    /** 获取全部景区弹窗唤醒 */
    allScenic() {
      this.allScenicShow = true;
    },

    /** 弹窗-时间 */
    selectTime() {
      this.$refs.rangeTime.showTime();
    },
    /** 时间 */
    getCurrentTime(value) {
      if (value) {
        this.beginTime = value[0].slice(0, 10);
        this.endTime = value[1].slice(0, 10);
        this.pageIndex = 1;
        this.pageSize = 10;
        this.listData = [];
        this.getAppointmentPageList();
      } else {
      }
    },

    /** 跳转至导旅行程单 */
    toScenicDetele(e) {
      sessionStorage.setItem('appointmentType', this.appointmentType);
      this.$router.push({
        name: "scenicDetele",
        params: {
          appointId: this.listData[e].appointId,
          appointmentType: this.appointmentType
        }
      });
    },
    selectCity() {
      if (this.localNum === 1) {
        this.resetAllCity();
      } else if (this.localNum === 3) {
        return;
      }
      this.$refs.commonpicker.showPicker();
    },

    resetAllCity() {
      this.typeListCity[0][0].children = [
        {
          text: "--",
          value: "",
          shortName: "",
          children: [
            {
              text: "--",
              value: "",
              shortName: "",
            }
          ]
        }
      ]
    },
    // 切换城市
    getCityValue(value) {
      if (value && value.length > 1) {
        if (value[1].text === "--") {
          this.cityChange = value[0].text;
          this.areaCode = value[0].value;
          this.showScenic = false;
        } else {
          this.cityChange = value[1].text;
          this.areaCode = value[1].value;
          this.showScenic = true;
        }
      } else if (value && value.length === 1) {
        this.cityChange = value[0].text;
        this.areaCode = value[0].value;
        this.showScenic = true
      }
      this.orgId = ''; /** 重置景区 **/
      
      /** 重置旅行社 **/
      this.travelAgentId = '';
      this.travelValue = '全部旅行社';
      this.travelInd = 0;
      
      this.pageIndex = 1; /** 页码重置 */
      this.listData = []; /** 数据重置 */
      this.resetScenic();
      this.getAppointmentPageList();
      this.getOrgList();
      this.getTravelList();
    },
    // 景区重置
    resetScenic() {
      this.scenicList = [];
      this.scenicValue = "全部景区";
      this.scenicInd = 0;
      this.orgName = "";
    },
    goSearch(type) {
      this.$router.push({
        path: "search",
        query: {
          searchType: type,
          appointmentType: this.appointmentType
        }
      });
    }
  }
};
</script>

<style lang="less">
.list {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background-color: #fbfbfb;
  padding: 40px 12px 48px 12px;
  .searchBox {
    margin-bottom: 16px;
    background-color: #f5f5f5;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;

    > img {
      display: inline-block;
      width: 15px;
      height: 15px;
      position: absolute;
      top: 8px;
      left: 12px;
    }

    > input {
      font-family: PingFang SC;
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 16px 0 36px;
      box-sizing: border-box;
      border-radius: 2px;
      background-color: #f5f5f5;
    }
    input::-webkit-input-placeholder {
      color: #999999;
    }
    input::-moz-input-placeholder {
      color: #999999;
    }
    input::-ms-input-placeholder {
      color: #999999;
    }
  }
  .btnBox {
    display: flex;
    padding: 24px 0 16px 0;
    font-size: 12px;
    text-align: center;
    line-height: 28px;
    div {
      &:first-child {
        margin-right: 16px;
      }
    }
    .btn {
      width: 72px;
      border: 1px solid #38b277;
      border-radius: 2px;
      color: #38b277;
    }
    .btn_active {
      width: 72px;
      background: #36b374;
      border: 1px solid #38b277;
      border-radius: 2px;
      color: white;
    }
  }
  .selectBox {
    // padding: 12px 0 12px 0;
    .selectType {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      height: 46px;
      line-height: 46px;
      // line-height: 22px;
      // line-height: 16px;
      color: #666;
      padding: 0 16px;
      .cityType {
        .cityTime {
          text-align: center;
          // padding-top: 1px;
          // margin-top: 3px;
          float: left;
          color: #36b374;
          margin-right: 6px;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .cityName {
          font-size: 20px;
          color: #333;
          font-weight: 700;
          float: left;
          margin-right: 6px;
          max-width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .cityNameImg {
          display: inline-block;
          width: 6px;
          height: 4px;
          // margin-top: 6px;
          vertical-align: middle;
        }
        .cityTimeImg {
          display: inline-block;
          margin-top: -2px;
          width: 12px;
          height: 12px;
          // margin-top: 4px;
          vertical-align: middle;
        }
      }
    }
  }
  .centerBox {
    margin-bottom: 15px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 15px 0 0 0;
    overflow: hidden;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    .topChoice {
      display: flex;
      justify-content: left;
      font-size: 12px;
      height: 14x;
      line-height: 16px;
      color: #666;
      padding: 0 16px;
      margin-bottom: 16px;
      .allScenicSelect {
        height: 14px;
        line-height: 14px;
        &:not(:last-child) {
          margin-right: 16px;
        }
        .city {
          float: left;
          max-width: 61px;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 6px;
        }
        img {
          float: right;
          display: inline-block;
          width: 6px;
          height: 4px;
          margin-top: 5px;
        }
      }
    }
    .scenicList {
      .scenicItem {
        padding: 16px 16px 8px 16px;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          width: 200%;
          height: 1px;
          background-color: #eeeeee;
          transform: scale(0.5);
          top: 0;
          left: -50%;
        }
        .scenicTitle {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          font-weight: 700;
          color: #333333;

          width: 280px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .scenicNav {
          display: flex;
          justify-content: space-between;
          .scenicLeft {
            .scenicLeftItem {
              color: #999999;
              display: flex;
              margin: 8px 0;
              .scenicLeftTitle {
                width: 68px;
              }
              .scenicLeftNav {
                width: 170px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              }
            }
          }
          .scenicRight {
            text-align: right;
            .scenicRightPeople {
              font-size: 20px;
              font-weight: bold;
              color: #36b374;
              margin-bottom: 7px;
            }
          }
        }
      }
    }
    .noScenicList {
      border-top: 1px solid #eeeeee;
      .noScenic {
        display: flex;
        justify-content: center;
        height: 155px;
        .noScenicItem {
          margin-top: 30px;
          .noScenicItemImg {
            margin-bottom: 24px;
            display: flex;
            justify-content: center;
            img {
              display: inline-block;
              width: 74px;
              height: 62px;
            }
          }
          .noScenicItemContent {
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }
  .contentCenter {
    padding: 0 16px;
    .search {
      background: #f9f9f9;
      height: 36px;
      line-height: 36px;
      margin-bottom: 24px;
      span {
        display: inline-block;
        margin-left: 12px;
        color: #999999;
      }
    }
    .content {
      .contentAllColor {
        color: #36b374;
      }
      .contentAll {
        margin: 16px 0;
        display: flex;
        justify-content: left;
        font-style: 14px;
        .contentAllTitle {
          font-size: 14px;
          font-weight: 400;
          color: #333;
        }
        .city {
          float: left;
          font-size: 14px;
          margin-right: 6px;
        }
        img {
          // float: right;
          margin-left: 8px;
          display: inline-block;
          width: 10px;
          height: 10px;
        }
      }
      .contentAll:last-child {
        margin-bottom: 36px;
      }
    }
  }
  .cancelIcon {
    width: 40px;
    height: 40px;
    position: absolute;
    background: #fff;
    right: 0;
    top: 0;
    div {
      width: 20px;
      height: 20px;
      margin-top: 12px;
    }
  }
  .van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .van-action-sheet__header {
    text-align: left;
    margin-left: 16px;
    color: #333;
    font-size: 16px;
  }
  .van-button--round {
    border-radius: 0px;
  }
  /deep/.md-popup-mask {
    background-color: rgba(37, 38, 45, 0.3);
  }
  /deep/.van-overlay {
    background-color: rgba(37, 38, 45, 0.3);
  }
}
</style>
